import { useKeycloak } from "@react-keycloak/ssr";
import { KeycloakInstance } from "keycloak-js";
import React, { useEffect } from "react";
import { BannerDataType } from "../Restricted.index";
import {
  ButtonDefault,
  Column,
  KeyHolder,
  KeyIcon,
  MainTitle,
  SubText,
} from "../Restricted.styled";

const restrictedStrings = {
  mainTitle: "Você se interessou por essa matéria?",
  subTitle: "Deseja utilizar uma chave para abrir o conteúdo?",
  buttonTitle: "Abrir",
};

type RestrictedType = {
  bannerData: BannerDataType | undefined;
  handleActionClick: any;
  trialSize: number;
};

type keysArrayType = {
  used: boolean;
};

const RestrictedTrialPaywall: React.FC<RestrictedType> = ({
  bannerData,
  handleActionClick,
  trialSize,
}) => {
 
  const keysArray: keysArrayType[] = [];

  useEffect(()=>{

  },[trialSize])

if(bannerData)
  for (let i = 0; i < bannerData?.chavesAcesso; i++) {
    if (trialSize > i) {
      keysArray.push({ used: true });
      continue;
    }
    keysArray.push({ used: false });
  }
  return (
    <>
    {bannerData && bannerData.chavesAcesso  > 0  &&
    <>
      <MainTitle customCss={{ mb: "$2", textAlign: "center" }}>
        {bannerData.chamadaPrincipal || restrictedStrings.mainTitle}
      </MainTitle>
      <Column
        customCss={{
          maxWidth: "auto",
          "@lg": { width: "100%" },
        }}
      >
        <SubText
          customCss={{
            fontSize: "18px",
            lineHeight: "23px",
            letterSpacing: "0.2px",
            fontWeight: 400,
            "@lg": { minHeight: "auto" },
          }}
        >
          {restrictedStrings.subTitle}
        </SubText>
        <KeyHolder>
          {keysArray.map((item, key) => {
            return <KeyIcon key={key} used={item.used}></KeyIcon>;
          })}
        </KeyHolder>
        <ButtonDefault onClick={handleActionClick}>
          {restrictedStrings.buttonTitle}
        </ButtonDefault>
      </Column>
      </>
      }
    </>
      
    
  );
};

export default RestrictedTrialPaywall;
